import { StrapiProduct } from "~/shared-types";
import { Price } from "../Price";
import { getOfferDetails } from "~/utils/getOfferDetails";
import QuantitySelector from "~/components/QuantitySelector";
import Button from "~/components/Button";
import Icon from "~/assets/icons/Icon";
import { ContactDialog } from "../ContactDialog";
import { Badge } from "~/components/Backroom/Badge";
import { FavoriteButton } from "~/components/FavoriteButton";
import { ShareBox } from "~/components/ShareBox";

type Props = {
  product: StrapiProduct;
  isBackroom?: boolean;
};

export const PurchaseInfo = ({ product, isBackroom }: Props) => {
  const { stockStatus, isUnique, price, store, showContactAboutStock } =
    product.attributes;
  const offerDetails = getOfferDetails(product);

  const priceDiv = (
    <div className="text-2xl flex-1 whitespace-nowrap">
      <Price offerDetails={offerDetails} price={price} />
    </div>
  );

  if (stockStatus !== "notInStock")
    return (
      <div className="flex flex-col items-start flex-wrap gap-5">
        <div className="flex flex-col gap-3 mb-7">
          {priceDiv}
          {isUnique && (
            <Badge className="hidden md:block" color="unique">
              Unika
            </Badge>
          )}
        </div>
        <div className="flex items-center md:flex-col md:items-start lg:flex-row lg:items-center">
          {isBackroom ? null : (
            <QuantitySelector
              className="flex-grow flex-shrink md:ml-0"
              productId={product.id}
              isUnique={isUnique}
            />
          )}
          <div className="flex">
            <FavoriteButton
              className="shrink-0 hidden md:block"
              favorite={{ id: product.id, type: "product" }}
            />
            <ShareBox className="shrink-0" product={product} />
          </div>
        </div>
      </div>
    );

  return (
    <>
      <div className="flex flex-col gap-3 mb-7">
        {priceDiv}
        <div className="hidden md:flex md:items-center md:gap-2">
          {isUnique && <Badge color="unique">Unika</Badge>}
        </div>
      </div>
      <div className="flex items-start gap-x-2 gap-y-2 flex-wrap">
        <Button className="flex" size="md" disabled>
          <Icon name="basketOutOfStock" />
          Ikke på lager
        </Button>
        <div className="flex md:flex-col lg:flex-row">
          {showContactAboutStock ? <ContactDialog store={store.data} /> : null}
          <div className="flex">
            <FavoriteButton
              className="shrink-0 hidden md:block"
              favorite={{ id: product.id, type: "product" }}
            />
            <ShareBox className="shrink-0" product={product} />
          </div>
        </div>
      </div>
    </>
  );
};
